export const SocialSharingEnum = {
    LANDING: 'landing',
    LAYOUT: 'layout',
}
